<h1 mat-dialog-title>
  {{
    isNew
      ? ('map.sidebar.raccordo-cavo.form.title_modal_new' | translate)
      : ('map.sidebar.raccordo-cavo.form.title_modal_edit' | translate : { name: raccordo?.nome_cavo ?? ' ' })
  }}
</h1>

<div mat-dialog-content>
  <form [formGroup]="form" *ngIf="form">
    <div class="container-fluid row">
      <h6 class="mb-4">Info edificio</h6>
      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.raccordo-cavo.form.building_search' | translate }}</mat-label>

          <input
            type="text"
            matInput
            formControlName="building"
            [matAutocomplete]="autoCompleteBuilding"
            [placeholder]="'map.sidebar.otdr.default.form.search_placeholder' | translate"
            [matTooltip]="
              form.get('building').disabled ? 'Non è possibile modificare i dati di un edificio già presente' : ''
            "
          />
          <mat-autocomplete #autoCompleteBuilding="matAutocomplete">
            <mat-option
              *ngFor="let result of searchResultsBuildings"
              [value]="result.desc"
              (click)="onSelectBuilding(result.urns)"
            >
              {{ result.desc }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="form.get('building').hasError('solrError')">
            <ng-container *ngTemplateOutlet="errorSolr"></ng-container>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.raccordo-cavo.form.building_name' | translate }}</mat-label>
          <input matInput formControlName="nome_edificio" readonly="false" />
          <mat-error *ngIf="form.get('nome_edificio').hasError('required')">
            <ng-container *ngTemplateOutlet="errorRequired"></ng-container>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.raccordo-cavo.form.building_alias' | translate }}</mat-label>
          <input matInput formControlName="alias" readonly="false" />
          <mat-error *ngIf="form.get('alias').hasError('required')">
            <ng-container *ngTemplateOutlet="errorRequired"></ng-container>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.raccordo-cavo.form.gat_sede' | translate }}</mat-label>
          <input matInput formControlName="gat_sede" readonly="false" />
          <mat-error *ngIf="form.get('gat_sede').hasError('required')">
            <ng-container *ngTemplateOutlet="errorRequired"></ng-container>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="container-fluid row">
      <h6 class="mb-4">Dati cavo</h6>
      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.raccordo-cavo.form.data_verbale' | translate }}</mat-label>
          <input formControlName="data_verbale" [matDatepicker]="picker" matInput />
          <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.raccordo-cavo.form.fattibilita' | translate }}</mat-label>
          <input matInput formControlName="codice_fattibilita" />
        </mat-form-field>
      </div>

      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.raccordo-cavo.form.td_raccordo' | translate }}</mat-label>
          <input matInput formControlName="td_raccordo" />
        </mat-form-field>
      </div>

      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.raccordo-cavo.form.nome_cavo' | translate }}</mat-label>
          <input matInput formControlName="nome_cavo" />
        </mat-form-field>
      </div>

      <div class="col-5 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.raccordo-cavo.form.potenzialita_cavo' | translate }}</mat-label>
          <input matInput formControlName="potenzialita_cavo" type="number" min="1" max="1728" step="1" 
          [matTooltip]="
              form.get('potenzialita_cavo').disabled ? 'Valore non modificabile dopo la creazione del cavo. Per variarlo è necessario ricreare il cavo.' : ''
            "
          />
          <mat-error *ngIf="form.get('potenzialita_cavo').hasError('required')">
            <ng-container *ngTemplateOutlet="errorRequired"></ng-container>
          </mat-error>
          <mat-error
            *ngIf="form.get('potenzialita_cavo').hasError('min') || form.get('potenzialita_cavo').hasError('max')"
          >
            {{ 'map.sidebar.raccordo-cavo.form.error_potenzialita_cavo_range' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-2 mb-4" *ngIf="isNew">
        <mat-checkbox formControlName="cavo_proprietario">
          {{ 'map.sidebar.raccordo-cavo.form.cavo_proprietario' | translate }}
        </mat-checkbox>
      </div>

      <div class="col-5 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.raccordo-cavo.form.potenzialita_iru' | translate }}</mat-label>
          <input matInput formControlName="potenzialita_iru" type="text" inputmode="numeric" 
          [matTooltip]="
            form.get('potenzialita_iru').disabled && !isNew && form.get('potenzialita_iru').value !== 'ND' ? 'Valore calcolato automaticamente in base al numero di fibre con stato `INUTILIZZABILE`. Per modificarlo agire sullo stato delle fibre del cavo.' : ''
          "
          />
          <mat-error *ngIf="form.get('potenzialita_iru').hasError('required')">
            <ng-container *ngTemplateOutlet="errorRequired"></ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('potenzialita_iru').hasError('pattern') || form.get('potenzialita_iru').hasError('min')">
            {{ 'map.sidebar.raccordo-cavo.form.error_potenzialita_iru_min' | translate }}
          </mat-error>
          <mat-error *ngIf="form.get('potenzialita_iru').hasError('iruMax')">
            {{ 'map.sidebar.raccordo-cavo.form.error_potenzialita_iru_max' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.raccordo-cavo.form.sala_1' | translate }}</mat-label>
          <input matInput formControlName="sala_1" />
          <mat-error *ngIf="form.get('sala_1').hasError('required')">
            <ng-container *ngTemplateOutlet="errorRequired"></ng-container>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-6 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.raccordo-cavo.form.sala_2' | translate }}</mat-label>
          <input matInput formControlName="sala_2" />
        </mat-form-field>
      </div>

      <div class="col-12 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.raccordo-cavo.form.terminazione_1' | translate }}</mat-label>

          <textarea
            matInput
            formControlName="terminazione_1"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="5"
          ></textarea>
          <mat-error *ngIf="form.get('terminazione_1').hasError('required')">
            <ng-container *ngTemplateOutlet="errorRequired"></ng-container>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-12 mb-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'map.sidebar.raccordo-cavo.form.terminazione_2' | translate }}</mat-label>
          <textarea
            matInput
            formControlName="terminazione_2"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="5"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="false" color="primary">{{ 'common.close' | translate }}</button>
  <button
    mat-raised-button
    color="primary"
    [disabled]="form.invalid"
    (click)="onSubmit()"
    *ngIf="form && this.isEditable"
  >
    {{ 'common.save' | translate }}
  </button>
</div>

<!-- FORM ERROR TEMPLATES -->
<ng-template #errorSolr>{{ 'map.sidebar.otdr.default.form.error_solr' | translate }}</ng-template>
<ng-template #errorOption>{{ 'map.sidebar.otdr.default.form.error_option' | translate }}</ng-template>

<ng-template #errorRequired>{{ 'map.sidebar.raccordo-cavo.form.error_required' | translate }}</ng-template>
<ng-template #latlonError>{{ 'map.sidebar.raccordo-cavo.form.lat_lon_error' | translate }}</ng-template>
